import React from "react"
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react';
import { useState } from 'react';
import {
    getMyLinkedhotels, gethotelcleaners, updateemployeetoroosterv2
} from "../dbconnector/connector";
import { setErrorMessage, setMessage, clearMessage } from "../tools/errorhandling";

import './css/tabs.css';

import Button from 'react-bootstrap/Button';
import Select from 'react-select';
import LoadingSpinner from '../customNodes/LoadingSpinner';

const AddToOtherRooster = (props) => {

    const [linkedhotels, setlinkedhotels] = useState([]);
    const [hotelOptions, setHotelOptions] = useState([]);
    const [selectedHotel, setSelectedHotel] = useState(null);
    const [linkedcleaners, setlinkedcleaners] = useState({});
    const [optionArray, setoptionArray] = useState([]);
    const [selectedCleaner, setselectedCleaner] = useState(null);
    const [loading, setLoading] = useState(true);

    const [confirmAction, setConfirmAction] = useState(false);

    const t = props.translation

    const navigate = useNavigate();

    const confirmAdd = async () => {
        setConfirmAction(false);
        const response = await updateemployeetoroosterv2({
            werknemer_Id: selectedCleaner,
            hotel_Id: selectedHotel,
            planned: 1
        });

        if (response.status !== 200) {
            setErrorMessage("Could not add employee to roster", response.message);
        }
        if(response.status === 200) {
            setMessage("Employee added to roster");
        }
    }

    const handleAdd = () => {
        if (selectedCleaner !== null && selectedHotel !== null) {
            setConfirmAction(true);
        }
    }

    async function fetchData() {
        setLoading(true);
        const response = await getMyLinkedhotels();
        const linkedhotelsresponse = await response.json();
        setlinkedhotels(linkedhotelsresponse.hotels);
        const options = linkedhotelsresponse.hotels.map((hotel) => ({ value: hotel.hotel_Id, label: hotel.naam }));
        setHotelOptions(options);
        setLoading(false);
    }

    const handleHotelChange = async (option) => {
        setSelectedHotel(option ? option.value : null);
        if(option) {
            const res = await gethotelcleaners(option.value);
            const data = await res.json();
            const cleaners = {};
            const opts = data.items.map((cleaner) => {
                cleaners[cleaner.id] = cleaner;
                return { value: cleaner.id, label: `${cleaner.voornaam} ${cleaner.achternaam}` };
            });
            setlinkedcleaners(cleaners);
            setoptionArray(opts);
        } else {
            setlinkedcleaners({});
            setoptionArray([]);
        }
        setselectedCleaner(null);
    }

    useEffect(() => {
        fetchData();
    }, [props.rights]);

    const selectchange = (option) => {
        setselectedCleaner(option ? option.value : null);
    }

    if (loading) return <LoadingSpinner />;

    return (
        <>
            <div id="main" className="Screendiv">
                <header>
                    <div id="errordiv" className='error'></div>
                    <div id="coverAllmessage" className="coverall" style={{ display: confirmAction ? "block" : "none" }}>
                        <div id="messagediv" className='message'>
                            <div id="messagetext" className="MessageText">Are you sure you want to add this employee to the roster?</div><br></br>
                            <center>
                                <div className='messageBoxes'>
                                    <Button type="button" id="CloseMessageButton" className="OkCancel messageBoxAlignRight" onClick={confirmAdd}>{t("OK")}</Button>
                                    <Button type="button" id="CancelMessageButton" className="OkCancel messageBoxAlignleft" onClick={() => { setConfirmAction(false); clearMessage(); }}>{t("Cancel")}</Button>
                                </div>
                            </center>
                        </div>
                    </div>
                </header>
                <div id="content">
                    <div className="noshow">
                        <h2>Select Hotel and Employee</h2>
                        <div id="AddToOtherHotelDiv">
                            <label htmlFor="hotelSelect">Choose hotel:</label>
                            <Select
                                id="hotelSelect"
                                className="NoShowSelect"
                                onChange={handleHotelChange}
                                options={hotelOptions}
                                value={hotelOptions.find(opt => opt.value === selectedHotel) || null}
                                placeholder="Select a hotel"
                                isSearchable
                            />
                            <label htmlFor="employeeSelect">Choose employee:</label>
                            <Select
                                id="employeeSelect"
                                className="NoShowSelect"
                                onChange={selectchange}
                                options={optionArray}
                                value={optionArray.find(opt => opt.value === selectedCleaner) || null}
                                placeholder="Select an employee"
                                isSearchable
                            />
                            <Button onClick={handleAdd} >Add to roster</Button>
                        </div>
                        <div class="result" id="resultMessage"></div>
                    </div>
                </div>
            </div>
        </>
    )

}

export default AddToOtherRooster
